'use client';

import { c as _c } from "react/compiler-runtime";
import React, { ComponentProps, useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import dynamic from 'next/dynamic';
import type { ReactQueryDevtools as ReactQueryDevtoolsType } from '@tanstack/react-query-devtools';
const ReactQueryDevtools = dynamic<ComponentProps<typeof ReactQueryDevtoolsType>>(() => import('@tanstack/react-query-devtools').then(mod => mod.ReactQueryDevtools), {
  ssr: false,
  loading: () => null
});
export function ReactQueryProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new QueryClient();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [client] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== client) {
    t3 = <QueryClientProvider client={client}>{children}{t2}</QueryClientProvider>;
    $[2] = children;
    $[3] = client;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}